var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgE7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.14 30.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-E7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1298081237824",
    "data-name": 1298081237824
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.07,4.77a3,3,0,0,1,5.15-2.15,3,3,0,0,1,.08,4A3,3,0,0,1,10.07,4.77ZM8.3,4.59c0,2.35,2,4.77,4.24,4.77,1.53,0,2.85-.09,4-1.46A4.74,4.74,0,1,0,8.3,4.59Z",
    transform: "translate(0 0)",
    fill: "#131e2f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.89,5.65c1.2,0,.25-.51,1.66-1.18.49-.23.71-.18.77-.64.14-1-1.14,0-1.62.15s-.88,0-1.26.18C11.69,4.51,12.18,5.65,12.89,5.65Z",
    transform: "translate(0 0)",
    fill: "#131e2f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.78,5.48c0,4.68-6.41,8.82-11.35,4.46C6.8,8.5,6.36,6.64,6.36,4.42,4,4.42,2.88,4.26,1.19,6.14A5.59,5.59,0,0,0,0,10.07V24.73C0,28,1.78,30.38,4.77,30.38h16.6c2.92,0,4.77-2.42,4.77-5.48v-15A5.51,5.51,0,0,0,24.87,6c-1.68-1.79-2.74-1.63-5.09-1.63V5.47Z",
    transform: "translate(0 0)",
    fill: "#131e2f",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgE7);
export default __webpack_public_path__ + "static/media/E7.d5e991041660fbe601d652a295681281.svg";
export { ForwardRef as ReactComponent };